// extracted by mini-css-extract-plugin
export default {"customScrollbar":"styles_customScrollbar__9WV4p","noScroll":"styles_noScroll__aduMY","custom-scrollbar":"styles_custom-scrollbar__3kRBo"};